import { FunctionComponent } from 'react'
import PricingIcon from './PricingIcon'
import PlanFeatureList from './PlanFeatureList'
import { OutlineCta, PlanCard, PlanCardHeader, PlanDescription, PlanFooter, PlanFooterNote, PlanPriceText, PlanTitle, PlanTitleBlock } from './PlanCard'
import { doneForYou } from '../pricingV2Content'

interface IDoneForYouCardProps {
    onBookCall: () => void
}

const DoneForYouCard: FunctionComponent<IDoneForYouCardProps> = ({ onBookCall }) => (
    <PlanCard>
        <PlanCardHeader>
            <PlanTitleBlock>
                <PlanTitle>{doneForYou.title}</PlanTitle>
                <PlanDescription>{doneForYou.description}</PlanDescription>
            </PlanTitleBlock>
            <PlanPriceText>{doneForYou.price}</PlanPriceText>
        </PlanCardHeader>
        <PlanFeatureList features={doneForYou.features} />
        <PlanFooter>
            <OutlineCta type="button" onClick={onBookCall}>Book a call<PricingIcon type="arrowRight" /></OutlineCta>
            <PlanFooterNote aria-hidden="true" />
        </PlanFooter>
    </PlanCard>
)

export default DoneForYouCard
